export default __webpack_public_path__ + "static/media/SocialMobile.2f242f66.png";